import { NewrelicPriorityQueue } from "./newrelicPriorityQueue";
import { filter, mapObjIndexed } from "ramda";
import { isNotNil } from "gather-common/dist/src/public/fpHelpers";
export const INTERVAL_LENGTH_MS = 30 * 1000;
export const MAX_ACTIONS_PER_INTERVAL = 120 - 1;
export var AddPageActionPriority;
(function (AddPageActionPriority) {
    AddPageActionPriority[AddPageActionPriority["Urgent"] = -1] = "Urgent";
    AddPageActionPriority[AddPageActionPriority["Default"] = 0] = "Default";
    AddPageActionPriority[AddPageActionPriority["Low"] = 1] = "Low";
})(AddPageActionPriority || (AddPageActionPriority = {}));
class NewRelicManager {
    static instance = new NewRelicManager();
    sendQueue = new NewrelicPriorityQueue();
    actionsSentLastInterval = 0;
    actionsSentThisInterval = 0;
    droppedActionsThisInterval = 0;
    interval;
    constructor() { }
    start() {
        this.interval = setInterval(() => this.processQueue(), INTERVAL_LENGTH_MS);
    }
    reset() {
        this.destroy();
        this.sendQueue = new NewrelicPriorityQueue();
        this.actionsSentLastInterval = 0;
        this.actionsSentThisInterval = 0;
        this.droppedActionsThisInterval = 0;
        this.start();
    }
    destroy() {
        this.interval && clearInterval(this.interval);
    }
    actuallyAddPageAction(...args) {
        this.actionsSentThisInterval += 1;
        window.newrelic?.addPageAction(...args);
    }
    processQueue() {
        const toSend = this.sendQueue.popN(MAX_ACTIONS_PER_INTERVAL - this.actionsSentThisInterval);
        toSend.forEach((args) => {
            this.actuallyAddPageAction(...args);
        });
        if (this.sendQueue.size() > 0 || this.droppedActionsThisInterval > 0) {
            const [maxFrequencyAction, maxFrequency] = this.sendQueue.highestFrequencyElement();
            this.actuallyAddPageAction("newRelicQueueOverflow", {
                droppedActions: this.droppedActionsThisInterval,
                pendingActions: this.sendQueue.size(),
                maxFrequency: maxFrequency || 0,
                maxFrequencyAction: maxFrequencyAction || "",
            });
        }
        this.actionsSentLastInterval = this.actionsSentThisInterval;
        this.actionsSentThisInterval = 0;
        this.droppedActionsThisInterval = 0;
    }
    addPageAction = (...args) => {
        if (this.actionsSentThisInterval + this.sendQueue.size() >= MAX_ACTIONS_PER_INTERVAL) {
            this.droppedActionsThisInterval++;
            return;
        }
        this.sendOrQueueAction(...args);
    };
    addPageActionReliably = (...args) => {
        this.sendOrQueueAction(...args);
    };
    sendOrQueueAction(name, attributes, priority = AddPageActionPriority.Default) {
        if (this.actionsSentThisInterval + this.actionsSentLastInterval >=
            MAX_ACTIONS_PER_INTERVAL) {
            this.sendQueue.push(priority, [name, attributes]);
        }
        else {
            this.actuallyAddPageAction(name, attributes);
        }
    }
    setCustomAttribute(...args) {
        window.newrelic?.setCustomAttribute(...args);
    }
    addRelease(releaseName, releaseId) {
        window.newrelic?.addRelease(releaseName, releaseId);
    }
    addMetric = this.addPageAction;
    addMetricReliably = this.addPageActionReliably;
    setAttribute = this.setCustomAttribute;
    getCurrentCustomAttributes = () => filter(isNotNil, mapObjIndexed((value) => (typeof value === "number" && !isNaN(value)) ||
        typeof value === "string" ||
        typeof value === "boolean"
        ? value
        : null, window.newrelic?.info.jsAttributes ?? {}));
}
export const newRelicManager = NewRelicManager.instance;
//# sourceMappingURL=newRelicManager.js.map